import { assert, Test } from "oc-e2e-testrunner";
import { assertEqualsBestellliste, resetArrangement } from "./utils";
import * as Maths from "oc-commons/Maths";

export default {
  name: "TestElementhalter",
};

export const testElementhalterGrazia: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [2]);
  agt.inspiration = APP.richMetadata.findAuswahlwert("Inspiration GRAZIA")?.Inspiration[0];
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createElementFromJson({
    detailSerie: "GRAZIA",
    form: "Anschluss",
    füllungAuswahlwert: "GRAZIA Füllung",
  });
  s.addPart(element);
  assert.equals("GRAZIA Füllung", element.füllungAuswahlwert.Key);
  agt.update3d();
  assert.equals(5, element.elementhalter.length);
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "1541",
        Anzahl: 1,
      },
      {
        ArtikelID: "1586",
        Anzahl: 1,
      },
      {
        ArtikelID: "1590",
        Anzahl: 1,
      },
      {
        ArtikelID: "1886",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
};

export const testElementhalterSquadra: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [2]);
  agt.inspiration = APP.richMetadata.findAuswahlwert(
    "Inspiration SQUADRA Sichtschutz Anthrazit"
  )?.Inspiration[0];
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createElementFromJson({
    detailSerie: "SQUADRA Sichtschutz",
    füllungAuswahlwert: "SQUADRA Anthrazit",
  });
  s.addPart(element);
  assert.equals("SQUADRA Anthrazit", element.füllungAuswahlwert.Key);
  agt.update3d();
  assert.deepEquals(
    [1.54, 0.88, 0.22, 1.54, 0.88, 0.22],
    element.elementhalter.map((e) => Maths.round(e.position.y, 2))
  );
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "2425",
        Anzahl: 1,
      },
      {
        ArtikelID: "1590",
        Anzahl: 2,
      },
      {
        ArtikelID: "725",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
};
